// extracted by mini-css-extract-plugin
export default {"container":"container_sv6VO","title":"title_jMiIt","list":"list_PxiWa","item":"item_LcFye","itemSmall":"itemSmall_dY6tQ","text":"text_ABzVL"};